import { render, staticRenderFns } from "./Layoutdms.vue?vue&type=template&id=7440d40a&"
import script from "./Layoutdms.vue?vue&type=script&lang=js&"
export * from "./Layoutdms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports